import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const MagicBox = () => {
	const block = document.querySelector(".magic-box");
	if (!block) {
		return;
	}
	gsap.registerPlugin(ScrollTrigger);
	let mm = gsap.matchMedia();
	const slidesEl = block.querySelectorAll(".magic-box__slide");
	const titlesEl = block.querySelectorAll(".magic-box__nav-title");
	const inner = block.querySelector(".magic-box__inner");
	const title = block.querySelector(".magic-box__title");
	const nav = block.querySelector(".magic-box__nav");

	const scrollTriggerRefresh = () => {
		ScrollTrigger.getAll().forEach((st) => {
			if (st.trigger.className.includes("steps-box__list")) {
				st.refresh();
			}
			if (st.trigger.className.includes("cases-box__list-wrap")) {
				st.refresh();
			}
		});
	};

	const playVideos = () => {
		slidesEl.forEach(slide => {
			const video = slide.querySelector("video");
			if (video) {
				video.play();
			}
		});
	};
	const pauseVideos = () => {
		slidesEl.forEach(slide => {
			const video = slide.querySelector("video");
			if (video) {
				video.pause();
			}
		});
	};

	mm.add("(max-width: 1023px)", () => {
		playVideos();
	});

	mm.add("(min-width: 1024px)", () => {
		gsap.timeline({
			scrollTrigger: {
				trigger: block,
				start: "top bottom",
				end: `+=${slidesEl[0].offsetHeight * (slidesEl.length + 2)}px`,
				scrub: true,
				onEnter: () => {
					playVideos();
					scrollTriggerRefresh();
				},
				onEnterBack: () => playVideos(),
				onLeave: () => pauseVideos(),
				onLeaveBack: () => pauseVideos()
			}
		});

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: inner,
				start: "top top",
				end: `+=${slidesEl[0].offsetHeight * slidesEl.length}px`,
				pin: true,
				scrub: true
			}
		});

		// set start titles X position
		// const navRect = nav.getBoundingClientRect();
		// titlesEl.forEach(title => {
		// 	const rect = title.getBoundingClientRect();
		// 	title.setAttribute("data-left", `${rect.left - navRect.left}px`);
		// });

		slidesEl.forEach((slide, i) => {
			// titles animation
			// const xPos = `-${navRect.left / 2 + titlesEl[i].offsetWidth / 2}px`;
			// titlesEl[i].style.position = "absolute";
			tl.set(titlesEl[i], { autoAlpha: 1, duration: 0.2 }, i);
			// tl.fromTo(titlesEl[i],
			// 	{ y: "35vh", left: "50%", marginLeft: xPos, scale: 1.5 },
			// 	{ y: 0, left: titlesEl[i].getAttribute("data-left"), marginLeft: 0, scale: 1, autoAlpha: 0.3, duration: 0.4 }
			// , i + 0.2);

			if (titlesEl[i]) {
				tl.fromTo(titlesEl[i],
					{ y: "35vh", scale: 1.5 },
					{ y: 0, scale: 1, autoAlpha: 0.3, duration: 0.4 }
				, i + 0.2);
			}

			const slideMedia = slide.querySelector(".magic-box__slide-media");
			const slideContentWrap = slide.querySelector(".magic-box__slide-content-wrap");
			if (i != 0) {
				tl.set(slide, { zIndex: 2 });
				if (slideMedia) {
					tl.from(slideMedia, { autoAlpha: 0 }, i);
				}
				if (slideContentWrap) {
					tl.from(slideContentWrap, { autoAlpha: 0, y: "75%" }, i);
				}
			}

			if (i != slidesEl.length - 1) {
				tl.set(slide, { zIndex: 1 });
				if (slideMedia) {
					tl.to(slideMedia, { autoAlpha: 0 }, i + 0.75);
				}
				if (slideContentWrap) {
					tl.to(slideContentWrap, { autoAlpha: 0, y: "-75%" }, i + 0.75);
				}
			}

			if (i === slidesEl.length - 1) {
				tl.to(title, { y: "-100%", autoAlpha: 0, duration: 0.4 }, i - 0.2);
				tl.to(nav, { left: 0, y: "30vh", marginLeft: 0, scale: 1.5, duration: 0.4 }, i + 0.2);

				titlesEl.forEach(title => {
					tl.to(title, { autoAlpha: 1, duration: 0.4 }, i + 0.2);
					tl.to(title.querySelector(".magic-box__nav-label"),
						{ transform: "translateX(0%)", left: 0, duration: 0.4 }
					, i + 0.2);
				});
			}
		});
	});
};

export default MagicBox;
